export const SETTING_TYPE_USER_SETTINGS: string = 'user-settings';
export const SETTING_TYPE_NOTIFICATION_SETTINGS: string = 'notification-settings';
